@if (block && !block.hidden && renderedText) {
  <div class="cms-text-block flex flex-col justify-center gap-[1rem]" [innerHTML]="renderedText"></div>
}
